import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import {
  USER_TOKEN_STATE_CHANGE,
  PESELECT_STATE_CHANGE,
} from "../../redux/constanst/index";
import Video from "../../videos/video.mp4";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import { blue } from "@mui/material/colors";
import SnackBar from "../funtComponents/snakBar";
import Sidebar from "../Sidebar";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import TextsmsIcon from "@mui/icons-material/Textsms";
import img1 from "../../images/T31Desc.jpg";
import img2 from "../../images/671469bd-e1e0-4577-a7eb-c73ecb70d484.__CR0,0,970,600_PT0_SX970_V1___.jfif";
import img3 from "../../images/202204150732153508219705545828f491651cd0cb1b6.png";
import logo from "../../images/megac.png";
import {
  Container,
  FormWrap,
  FormState,
  FormContent,
  Form,
  FormH1,
  FormInput,
  Text,
  Text2,
  HeroBg,
  InfoSlide,
  HeroWrapper,
  ItemButtom,
  LogoMC,
  ImageWrapper,
  InfoWrapper,
  VideoBg,
  Transparent,
  HeroContent,
} from "./signinElements";
import { hosting, mapStateToProps } from "../funtComponents/models/buscar";
import axios from "axios";
import Slider2 from "./Slider2";

import "./styles.css";
const code = require("jwt-encode");

const SignIn = (props) => {
  const dispatch = useDispatch();
  const ip = window.location;
  let ip2 = ip.toString();
  localStorage.setItem("ip", ip2);
  const [open, setOpen] = React.useState(false);
  const [formType, setFormType] = useState("signin");
  const [alertType, setAlertType] = useState("");
  const [alertText, setAlertText] = useState("");

  const [sContain, setScontain] = useState({
    url: img1,
    contain:
      "El Yealink T30P es un teléfono IP clásico para usuarios de pequeñas empresas, el SIP-T30P ofrece una experiencia de marcación moderna y fácil de usar. Tiene una pantalla LCD gráfica de 132x64 píxeles enormemente grande que garantiza un acceso más fácil a mucha más información visual.",
    title: "Yealink-T31G-T31P",
  });

  const [slide, setSlide] = useState(false);

  const [datos, setDatos] = useState({
    email: "",
    password: "",
  });

  const jwtLogin = async (secret, sub2, name22, iat2) => {
    const data = {
      sub: sub2,
      name: name22,
      iat: iat2,
      admin: false,
    };
    const jwt = code(data, secret);
    localStorage.setItem("key", jwt);
  };
  const Check = async () => {
    const url = `${hosting}/mimegacall/api/login.php`;
    var formData = new FormData();
    formData.append("user", datos.email);
    formData.append("pass", datos.password);
    const resp = await fetch(`${url}`, {
      headers: {
        Accept: "application/json",
      },
      method: "POST",
      body: formData,
    });

    console.log("Hola Raymer");
    const respBody = await resp.json();

    if (respBody.scalar !== false) {
      localStorage.setItem("key", respBody);

      dispatch({ type: USER_TOKEN_STATE_CHANGE, token: respBody });

      dispatch({ type: PESELECT_STATE_CHANGE, preselect: true });
    } else {
      handleClick();
    }
  };

  const ColorButton = styled(Button)(({ theme }) => ({
    color: theme.palette.getContrastText(blue[500]),
    backgroundColor: blue[500],
    "&:hover": {
      backgroundColor: blue[700],
    },
  }));

  const handleChange = (event) => {
    setDatos({
      ...datos,
      [event.target.name]: event.target.value,
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    /* checkTest() */
    Check();
  };

  const handleRecover = (event) => {
    if (alertText !== "Contraseña recuperada con éxito") {
      setDatos({ email: "" });
      setAlertType("success");
      setAlertText("Contraseña recuperada con éxito");
    }
  };
  const handlerConfirm = (event) => {
    const config = { "Content-Type": "multipart/form-data" };
    const formData = new FormData();
    formData.append("user", datos.email);
    axios
      .post(`${hosting}/mimegacall/api/email.php`, formData, config)
      .then(function (response) {
        setAlertType(response.data.status);
        setAlertText(response.data.mensaje);
        if (response.data.status === "success") {
          setFormType("signin");
        }

        setOpen(true);
      })
      .catch(function (error) {});
  };

  const handleClick = () => {
    if (
      alertText !== "Los datos ingresados no son correctos, intente nuevamente."
    ) {
      setAlertText(
        "Los datos ingresados no son correctos, intente nuevamente."
      );
      setAlertType("warning");
      setOpen(true);
    }
  };

  const handleSlider = async () =>{
      const sliderResult = await axios.get(`https://www.megacall.cl/mimegacall/slider.json`);
      setSlide(sliderResult.data.slider)
  }

  useEffect(() => {
    handleSlider()
  }, []);
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertText("");
    setOpen(false);
  };

  const recover = () => {
    setDatos({ email: "" });

    setFormType("lostPassword");
  };

  const ContainSelect = (item) => {
    setScontain({
      url: item.url,
      contain: item.contain,
      title: item.title,
    });
  };

  return (
    <>
      <Container>
        <HeroBg>
          <VideoBg autoPlay loop muted src={Video} type="video/mp4">
            <Transparent />
          </VideoBg>
        </HeroBg>

        <HeroContent>
          <InfoWrapper>
            <HeroBg className="toolBar" style={{ flexDirection: "column", paddingBottom: 20 }}>
              {slide ? <Slider2 slider={slide} />: "Cargando..."}
            </HeroBg>

            <FormState>
              <HeroWrapper>
                <div
                  style={{
                    flex: 1,
                    width: "100%",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "white",
                  }}
                >
                  <ImageWrapper
                    style={{ cursor: "pointer" }}
                    onClick={() => setFormType("signin")}
                  >
                    <LogoMC src={logo} />
                  </ImageWrapper>
                </div>

                <SnackBar
                  open={open}
                  handleClick={handleClick}
                  handleClose={handleClose}
                  alertType={alertType}
                  alertText={alertText}
                />

                <div
                  style={{
                    flex: 9,
                    width: "100%",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {formType === "signin" && (
                    <FormWrap>
                      <FormContent>
                        <Form action="#">
                          <FormH1>Ingresa con tu usuario</FormH1>
                          <FormInput
                            placeholder="Correo"
                            type="email"
                            name="email"
                            onChange={handleChange}
                          />

                          <FormInput
                            placeholder="Contraseña"
                            type="password"
                            name="password"
                            onChange={handleChange}
                          />

                          <Text2 onClick={handleSubmit} variant="contained">
                            Continuar
                          </Text2>

                          <Text onClick={recover}>Olvidé mi contraseña</Text>
                        </Form>
                      </FormContent>
                    </FormWrap>
                  )}
                </div>

                <div
                  style={{
                    flex: 9,
                    width: "100%",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {formType === "lostPassword" && (
                    <FormWrap>
                      <FormContent>
                        <Form action="#">
                          <FormH1>Recuperando tu usuario</FormH1>
                          <FormInput
                            placeholder="Correo"
                            type="email"
                            name="email"
                            onChange={handleChange}
                          />

                          <ColorButton
                            onClick={handlerConfirm}
                            variant="contained"
                          >
                            Solicitar recuperación
                          </ColorButton>

                          <Text onClick={() => setFormType("signin")}>
                            volver atrás
                          </Text>
                        </Form>
                      </FormContent>
                    </FormWrap>
                  )}
                </div>

                <div
                  style={{
                    flex: 9,
                    width: "100%",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {" "}
                  {formType === "checkPin" && (
                    <FormWrap>
                      <FormContent>
                        <Form action="#">
                          <FormInput
                            placeholder="Correo"
                            type="email"
                            name="email"
                            onChange={handleChange}
                          />

                          <FormInput
                            placeholder="Nueva Contraseña"
                            type="password"
                            name="password"
                            onChange={handleChange}
                          />
                          <ColorButton
                            onClick={handleRecover}
                            variant="contained"
                          >
                            Continuar
                          </ColorButton>
                          <FormInput
                            placeholder="Pin de recuperación"
                            type="password"
                            name="password"
                            onChange={handleChange}
                          />
                        </Form>
                      </FormContent>
                    </FormWrap>
                  )}
                </div>
              </HeroWrapper>
              <Text
                style={{
                  color: "white",
                  fontWeight: "bold",
                  position: "fixed",
                  bottom: "10px",
                  right: "10px",
                }}
              >
                v1.0
              </Text>
            </FormState>
          </InfoWrapper>
        </HeroContent>

        <Sidebar />
      </Container>
    </>
  );
};

export default connect(mapStateToProps, null)(SignIn);
